const basico7 = {
  titulo: `JavaScript: condiciones compuestas con operadores lógicos`,
  problemas: [
    {
      codigo: 1,
      descripcion: `Hemos aprendido los operadores relacionales: ==, ===, !=, !==, >, >=, <, <=
Ahora vamos a aprender los operadores lógicos: 
<pre>
&& significa 'y'
|| significa 'o'
!  significa 'no'	
</pre>
Los operadores lógicos son muy útiles para aplicar en las estructuras condicionales. 
El primero que veremos es el operador && (significa 'y') 
<pre>
if (condicion1 && condicion2) {
    // Ejecutar la rama del verdadero si las dos condiciones son verdaderas.
} else {
    // Ejecutar la rama del falso
}
</pre>
Una condición de un if puede estar formada por dos condiciones simples, luego si la Condicion1 es verdadera "Y" la condicion2 es verdadera luego ejecutar la rama del verdadero.
Cuando vinculamos dos condiciones con el operador &&, las dos condiciones deben ser verdaderas para que el resultado de la condición compuesta de verdadero y continúe por la rama del verdadero de la estructura condicional.
La utilización de operadores lógicos permiten en muchos casos plantear algoritmos más cortos y comprensibles.
Problema: Confeccionar un programa que defina tres variables enteras y nos muestre el mayor. Este problema ya lo resolvimos cuando trabajamos con estructuras condicionales anidadas, ahora podemos ver que es mucho más conciso con el uso de operadores lógicos.`,
      programa: `let num1 = 80
let num2 = 13
let num3 = 7
if (num1 > num2 && num1 > num3) {
  console.log(num1)
} else {
  if (num2 > num3) {
    console.log(num2)
  } else {
    console.log(num3)
  }
}`,
      solucion: "80",
    }, {
      codigo: 2,
      descripcion: `Se tienen tres variables que representan una fecha, mostrar un mensaje por la consola si dicha fecha corresponde a Navidad.`,
      programa: `let dia = 25
let mes = 12
let año = 2022
if (dia === 25 && mes === 12) {
  console.log("Navidad")
}`,
      solucion: "'Navidad'",
    }, {
      codigo: 3,
      descripcion: `Se tienen 3 variables con valores enteros. Mostrar un mensaje si tienen el mismo valor.`,
      programa: `let num1 = 10
let num2 = 10
let num3 = 10
if (num1 == num2 && num1 == num3) {
  console.log("Todos iguales")
} else {
  console.log("No todos son iguales")
}`,
      solucion: "'Todos iguales'",
    }, {
      codigo: 4,
      descripcion: `Definir dos variables con valores enteros que representan la coordenada de un punto en el plano, es decir dos valores x e y (distintos a cero)
Posteriormente imprimir en pantalla en que cuadrante se ubica dicho punto. 
<pre>
Sabiendo que 	1º Cuadrante si x > 0 Y y > 0 
                2º Cuadrante:   x < 0 Y y > 0
                3º Cuadrante:   x < 0 Y y < 0
                4º Cuadrante:   x > 0 Y y < 0
</pre>`,
      programa: `let x = -5
let y = -2
if (x > 0 && y > 0) {
  console.log("Primer cuadrante")
} else {
  if (x < 0 && y > 0) {
    console.log("Segundo cuadrante")
  } else {
    if (x < 0 && y < 0) {
      console.log("Tercer cuadrante")
    } else {
      if (x > 0 && y < 0) {
        console.log("Cuarto cuadrante")
      } else {
        console.log("Sobre un eje")
      }
    }
  }
}`,
      solucion: "'Tercer cuadrante'",
    }, {
      codigo: 5,
      descripcion: `El segundo operador lógico es el || (significa 'o')
<pre>
if (condicion1 || condicion2) {
    // Ejecutar la rama del verdadero 
    // si al menos una de las dos condiciones es verdadera.
} else {
    // Ejecutar la rama del falso      
}
</pre>
Cuando vinculamos dos condiciones con el operador ||, con que una de ellas sea verdadera, el resultado de la condición compuesta da verdadero y continúa por la rama del verdadero de la estructura condicional. Las dos deben ser falsas para que el resultado de la condición compuesta de falso y continúe por la rama del falso de la estructura condicional.
Se definen tres variables que representan una fecha (día, mes y año). Mostrar un mensaje si corresponde al primer trimestre del año`,
      programa: `let dia = 1
let mes = 3
let año = 2022
if (mes == 1 || mes == 2 || mes == 3) {
  console.log('Corresponde al primer trimestre')
} else {
  console.log('No corresponde al primer trimestre')
}`,
      solucion: "'Corresponde al primer trimestre'",
    }, {
      codigo: 6,
      descripcion: ` Se definen tres variables con valores enteros, si al menos uno de los valores es menor a 10, imprimir en pantalla la leyenda "Alguno de los números es menor a diez". `,
      programa: `let valor1 = 12
let valor2 = 9
let valor3 = 67
if (valor1 < 10 || valor2 < 10 || valor3 < 10) {
  console.log("Alguno de los números es menor a diez")
}`,
      solucion: "'Alguno de los números es menor a diez'",
    }, {
      codigo: 7,
      descripcion: `Definir una variable y guardar una letra, luego verificar si es una vocal o no.`,
       programa: `let letra = "e"
if (letra == "a" || letra == "e" || letra == "i" || letra == "o" || letra == "u") {
  console.log("La letra es una vocal")
} else {
  console.log("La letra no es una vocal")
}`,
      solucion: "'La letra es una vocal'",
    }, {
      codigo: 8,
      descripcion: `Definir una variable y cargar el número de un mes cualquiera del año. Mostrar un mensaje si dicho mes tiene 31 días, 30 días o si se trata de febrero que tiene 28 o 29 días dependiendo del año`,
       programa: `let mes = 8
if (mes == 1 || mes == 3 || mes == 5 || mes == 7 || mes == 8 || mes == 10 || mes == 12) {
  console.log("Tiene 31")
} else {
  if (mes == 4 || mes == 6 || mes == 9 || mes == 11) {
    console.log("Tiene 30")
  } else {
    console.log("Tiene 28 o 29 dias el mes de febrero")
  }
}`,
      solucion: "'Tiene 31'",
    }, {
      codigo: 9,
      descripcion: `El último operador lógico es el ! (significa 'no') 
<pre>
if (!condicion) {
    // Ejecutar la rama del falso
} else {
    // Ejecutar la rama del verdadero
}
</pre>
Si la condición se verifica verdadera el operador ! invierte el resultado de la condición y genera un falso para la condición del if.
<pre>
let x = 30
if (!(x > 10)) {
  console.log("x es menor a 10")
} else {
  console.log("x es mayor a 10")
}
</pre>
Si x tiene un 11 o un valor mayor luego se verifica verdadero que x > 10, pero el ! invierte el resultado de la condición y se ejecuta la rama del falso.`,
       programa: `let x = 30
if (!(x > 10)) {
  console.log("x es menor a 10")
} else {
  console.log("x es mayor a 10")
}
`,
      solucion: "'x es mayor a 10'",
    }, {
      codigo: 10,
      descripcion: `Un tipo de variable que todavía no hemos trabajado es el booleano. Puede almacenar solo alguno de estos dos valores: true o false.
Las variable booleanas son comunmente utilizadas en condiciones.`,
       programa: `let tieneEstudios = true
if (tieneEstudios) {
  console.log('Tiene estudios')
} else {
  console.log('No tiene estudios')
}`,
      solucion: "'Tiene estudios'",
    }, {
      codigo: 11,
      descripcion: ``,
       programa: `let existe = true
if (!existe) {
  console.log('No existe')
} else {
  console.log('Existe')
}`,
      solucion: "'Existe'",
    }
  ]
}

export default basico7;